<div class="table-page dashboard-page">
  <header class="header">
    <div class="title-row">
      <button type="button" class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <h1 class="title">داشبورد پیش ثبت‌نام ها</h1>
      <div class="actions">
        <button type="button" class="btn btn-primary" [disabled]="isLoading" (click)="initialization()">
          <i class="fa fa-refresh" aria-hidden="true"></i> به روز رسانی
        </button>
      </div>
    </div>
  </header>
  <div class="dashboard-grid" [attr.aria-busy]="isLoading">
    <section class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-tree-scroll">
        <app-chart [context]="domainChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart">
      <div>
        <app-chart [context]="installationStatusChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart">
      <div>
        <app-chart [context]="floatingTypeChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="registrationDateChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div>
        <app-chart [context]="announcementDateChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart">
      <div>
        <app-chart [context]="installerPlanChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart">
      <div>
        <app-chart [context]="installationDateChart"></app-chart>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-map-heading">
        <h2 class="dashboard-card-title">پراکندگی پیش ثبت‌نام ها</h2>
      </div>
      <div class="dashboard-map">
        <div id="Preregistration_Map" class="fixed-mapCluster" role="region" aria-label="پراکندگی پیش ثبت‌نام ها">
          <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>
        </div>
      </div>
    </section>
    <section class="card dashboard-chart dashboard-chart--wide">
      <div class="dashboard-map-heading">
        <h2 class="dashboard-card-title">پراکندگی نصب</h2>
      </div>
      <div class="dashboard-map">
        <div id="InstallMap" class="fixed-mapCluster" role="region" aria-label="پراکندگی نصب">
          <div class="position-absolute" id="install_map_tooltip" data-bs-html="true"></div>
        </div>
      </div>
    </section>
  </div>
</div>
